import React from "react"



const StepFour = () => {
    return(
        <div className="step-4 steps">
              <div className="display-lap2">
                <h1>Repayments</h1>
                <p>Typically, repayments are set up automatically through your payroll by your employer. But with some employers, employees are required to set up repayments on their own using card payment, direct debit or post-dated cheques.</p>
            </div>
        </div>
    )
}

export default StepFour